import PropTypes from "prop-types";

import { Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { formatDate, formatNumber } from "@/features/shared";

// Read-only by construction: the API mirrors the source amounts and refuses any
// the client sends, so there is nothing to edit here.
export const PurchaseInvoicePaymentsSection = ({ purchaseInvoicePayments }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Stack spacing={2}>
        <Typography variant="subtitle1">Alokasi Faktur</Typography>
        <DataGrid
          rows={purchaseInvoicePayments}
          getRowHeight={() => "auto"}
          columns={[
            {
              field: "purchaseInvoice",
              headerName: "Faktur #",
              flex: 2,
              sortable: false,
              // Plain text, not a link: the invoice belongs to the paying
              // outlet, so the hub cannot open it. Shown in full for the same
              // reason — with nothing to click through to, the prefix and date
              // are the only clue to which document this is.
              valueGetter: (purchaseInvoice) =>
                purchaseInvoice?.referenceNumber || "-",
            },
            {
              field: "transactionDate",
              headerName: "Tanggal",
              flex: 1,
              sortable: false,
              valueGetter: (_, row) =>
                row.purchaseInvoice?.transactionDate
                  ? formatDate(row.purchaseInvoice.transactionDate)
                  : "-",
            },
            {
              field: "grandTotal",
              headerName: "Total Faktur",
              flex: 1,
              type: "number",
              sortable: false,
              valueGetter: (_, row) =>
                formatNumber(row.purchaseInvoice?.grandTotal ?? 0),
            },
            {
              field: "allocatedAmount",
              headerName: "Bayar",
              flex: 1,
              type: "number",
              sortable: false,
              valueGetter: (value) => formatNumber(value),
            },
            {
              field: "discount",
              headerName: "Diskon",
              flex: 1,
              type: "number",
              sortable: false,
              valueGetter: (value) => formatNumber(value),
            },
          ]}
          hideFooter
          disableRowSelectionOnClick
        />
      </Stack>
    </Paper>
  );
};

PurchaseInvoicePaymentsSection.propTypes = {
  purchaseInvoicePayments: PropTypes.arrayOf(PropTypes.object).isRequired,
};
